import { render, staticRenderFns } from "./transport_detail.vue?vue&type=template&id=e23c9fd4&scoped=true"
import script from "./transport_detail.vue?vue&type=script&lang=js"
export * from "./transport_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23c9fd4",
  null
  
)

export default component.exports